module.exports = __webpack_public_path__ + "media/images/payments/giropay-dark-8c013431afbeac1c0a0188ae158d3020.svg";